export const translations = {
  en: {
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.services": "Services",
    "nav.projects": "Projects",
    "nav.process": "Process",
    "nav.estimate": "Estimate",
    "nav.contact": "Contact",
    "cta.consult": "Get a Free Consultation",
    "cta.whatsapp": "WhatsApp Us",
    "cta.call": "Call Now",
    "cta.explore": "Explore Our Projects",
    "cta.discuss": "Discuss Your Project",
    "cta.learnMore": "Learn More",
    "cta.meetDn": "Meet D & N",
    "cta.talkTeam": "Not sure what to choose? Talk to our team.",
    "cta.submit": "Submit Enquiry",
    "cta.next": "Next",
    "cta.back": "Back",
    "cta.skip": "Skip",
    "cta.skipAll": "Skip all and continue",
    "cta.close": "Close",
    "cta.retry": "Try Again",
    "cta.viewAll": "View All Projects",
    "hero.eyebrow": "D & N Constructions · Tumakuru · Bengaluru",
    "hero.h1a": "We build.",
    "hero.h1b": "You belong.",
    "hero.sub": "From planning and design to construction and finishing, D & N Constructions brings your vision together under one roof.",
    "hero.scroll": "Scroll",
    "stats.years": "Years of Experience",
    "stats.projects": "Projects Completed",
    "stats.capability": "Construction Capability",
    "stats.coverage": "Service Coverage",
    "about.eyebrow": "Who We Are",
    "about.title": "Building more than structures.",
    "about.body": "D & N Constructions is a full-service construction company serving Tumakuru, Bengaluru and surrounding areas. We handle everything from planning and design to construction and handover — while keeping you at the centre of every decision.",
    "about.p1": "Professional planning",
    "about.p2": "Quality construction",
    "about.p3": "Transparent communication",
    "about.p4": "Customized to your vision",
    "about.p5": "Experienced teams",
    "about.p6": "Local knowledge",
    "about.p7": "End-to-end execution",
    "services.eyebrow": "What We Do",
    "services.title": "Every service your project needs.",
    "services.sub": "Choose a single service or let us handle everything end-to-end.",
    "why.eyebrow": "Why D & N",
    "why.title": "Built on trust, finished with care.",
    "process.eyebrow": "How We Work",
    "process.title": "From idea to handover.",
    "process.note": "This is an illustrative overview — our detailed process flow is currently being finalized with the D & N team and will be updated here soon.",
    "projects.eyebrow": "Our Work",
    "projects.title": "Homes and spaces we're proud of.",
    "projects.filterLocation": "Location",
    "projects.filterType": "Project Type",
    "projects.all": "All",
    "projects.empty": "We're updating our project portfolio. Try another category or speak with our team about your project.",
    "projects.viewCase": "View Project",
    "materials.eyebrow": "Materials & Customization",
    "materials.title": "Your home. Your choices. Our expertise.",
    "materials.sub": "Every project can be tailored with different material and specification choices. Brand details are finalized together with you during planning.",
    "materials.structure": "Structure",
    "materials.exterior": "Exterior",
    "materials.interior": "Interior",
    "materials.utilities": "Utilities",
    "materials.brandsNote": "Specific brands and specifications are confirmed with you and managed by the D & N team.",
    "turnkey.eyebrow": "Two Ways To Build",
    "turnkey.title": "Choose what works for you.",
    "turnkey.individual": "Individual Services",
    "turnkey.individualDesc": "Select only the services you need — design, structural planning, renovation, interiors, electrical, plumbing, flooring, painting or landscaping.",
    "turnkey.full": "Complete Turnkey",
    "turnkey.fullDesc": "D & N handles your project end-to-end — planning, approvals, construction, finishing and handover — with one accountable team.",
    "founders.eyebrow": "The People Behind D & N",
    "founders.title": "Built by founders who answer their phone.",
    "founders.body": "D & N Constructions is led personally by its founders. You speak directly with the people responsible for your project — no layers, no runaround.",
    "testimonials.eyebrow": "Testimonials",
    "testimonials.title": "What our customers say.",
    "testimonials.pending": "Real customer reviews are being collected and will appear here soon — including Google reviews once officially linked.",
    "testimonials.leaveReview": "Leave a Review",
    "testimonials.viewGoogle": "View All Google Reviews",
    "faq.eyebrow": "FAQ",
    "faq.title": "Questions, answered.",
    "areas.eyebrow": "Service Area",
    "areas.title": "Where we work.",
    "areas.notListed": "Is your location not listed? Contact us.",
    "finalCta.title": "Ready to build something that feels like yours?",
    "finalCta.sub": "Your home begins with an idea. We help turn that idea into a place that feels like yours.",
    "estimate.title": "Request a Project Estimate",
    "estimate.sub": "Every project is different. Tell us about your requirements and our team will understand your project and get back to you with an estimate.",
    "estimate.success": "Thank you. We've received your project enquiry. The D & N Constructions team will contact you to understand your requirements and provide the appropriate estimate.",
    "estimate.continueWa": "Continue on WhatsApp",
    "form.location": "Location",
    "form.category": "Project Category",
    "form.plotArea": "Plot Area (optional)",
    "form.builtUp": "Built-up Area (optional)",
    "form.floors": "Floors",
    "form.preference": "Construction Preference",
    "form.timeline": "Timeline",
    "form.requirements": "Additional Requirements (optional)",
    "form.name": "Your Name",
    "form.phone": "Phone Number",
    "form.email": "Email (optional)",
    "form.message": "Message (optional)",
    "form.optional": "Optional",
    "form.required": "Required",
    "form.nameRequired": "Please enter your name.",
    "form.phoneRequired": "Please enter your phone number.",
    "form.phoneInvalid": "Please enter a valid 10-digit mobile number.",
    "form.emailInvalid": "Please enter a valid email address.",
    "form.error": "Something went wrong while sending your enquiry. Please try again or contact us directly on WhatsApp.",
    "form.sending": "Sending…",
    "consult.step1": "What are you planning to build?",
    "consult.step2": "Where is the project located?",
    "consult.step3": "Tell us about the property.",
    "consult.step4": "When would you like to begin?",
    "consult.step5": "How can we contact you?",
    "consult.stepOf": "Step {x} of 5",
    "consult.successTitle": "Thank you!",
    "consult.success": "We've received your enquiry. The D & N Constructions team will contact you shortly.",
    "contact.eyebrow": "Contact",
    "contact.title": "Let's talk about your project.",
    "contact.office": "Office",
    "contact.phone": "Phone",
    "contact.whatsapp": "WhatsApp",
    "contact.email": "Email",
    "contact.map": "Open in Google Maps",
    "contact.send": "Send Message",
    "contact.success": "Thank you. We've received your message and will get back to you soon.",
    "footer.tagline": "We build. You belong.",
    "footer.rights": "© D & N Constructions. All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms & Conditions",
    "footer.socialSoon": "Link coming soon",
    "footer.kannadaNote": "ಕನ್ನಡ version is being prepared.",
    "caseStudy.overview": "Project Overview",
    "caseStudy.vision": "Client Vision",
    "caseStudy.challenge": "Challenge",
    "caseStudy.approach": "D & N Approach",
    "caseStudy.gallery": "Gallery",
    "caseStudy.beforeAfter": "Before / After",
    "caseStudy.related": "Related Projects",
    "caseStudy.cta": "Have a vision of your own?",
    "caseStudy.location": "Location",
    "caseStudy.type": "Project Type",
    "caseStudy.floors": "Floors",
    "caseStudy.status": "Status",
    "caseStudy.year": "Completed",
    "caseStudy.builtUp": "Built-up Area",
    "caseStudy.plot": "Plot Size",
    "common.notProvided": "Not provided",
  },
  kn: {
    "nav.home": "ಮುಖಪುಟ",
    "nav.about": "ನಮ್ಮ ಬಗ್ಗೆ",
    "nav.services": "ಸೇವೆಗಳು",
    "nav.projects": "ಯೋಜನೆಗಳು",
    "nav.process": "ಪ್ರಕ್ರಿಯೆ",
    "nav.estimate": "ಅಂದಾಜು",
    "nav.contact": "ಸಂಪರ್ಕ",
    "cta.consult": "ಉಚಿತ ಸಮಾಲೋಚನೆ ಪಡೆಯಿರಿ",
    "cta.whatsapp": "ವಾಟ್ಸಾಪ್ ಮಾಡಿ",
    "cta.call": "ಈಗಲೇ ಕರೆ ಮಾಡಿ",
    "hero.h1a": "ನಾವು ಕಟ್ಟುತ್ತೇವೆ.",
    "hero.h1b": "ನೀವು ಸೇರುತ್ತೀರಿ.",
  },
};
